/* global Swiper */
const imageSliderElement = document.querySelectorAll('[data-slider="image-slider"]');

// *******************************************************************************
// 1.0 - Image slider
// *******************************************************************************

Array.prototype.forEach.call(imageSliderElement, (el) => {
  const imageSliderParent = el.closest('.image-slider');
  const arrowRight = imageSliderParent.querySelectorAll('.image-slider__arrow.arrow--right');
  const arrowLeft = imageSliderParent.querySelectorAll('.image-slider__arrow.arrow--left');
  const imageSliderElementOptions = {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 1000,
    spaceBetween: 0,
    navigation: {
      nextEl: arrowRight,
      prevEl: arrowLeft,
    },
  };
  // eslint-disable-next-line no-unused-vars
  const imageSlider = new Swiper(el, imageSliderElementOptions);
});
